export const infoData = [
  { id: "100M", name: "100 Mb/s" },
  { id: "1G", name: "1 Gb/s" },
  { id: "2.5G", name: "2.5 Gb/s" },
  { id: "5G", name: "5 Gb/s" },
  { id: "10G", name: "10 Gb/s" },
  { id: "Any", name: "Any" }
];
